// src/components/HomePage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Row, Col } from 'react-bootstrap';
import './style.css'; // Đảm bảo bạn đã import CSS

function HomePage() {
  const navigate = useNavigate();
  const role = localStorage.getItem('role'); // Lấy role từ localStorage
  const chuc_danh = localStorage.getItem('chuc_danh');

  useEffect(() => {
    // Kiểm tra nếu role là 'driver' thì tự động điều hướng đến '/drive'
    if (role === 'driver') {
      navigate('/drive');
    }
    // Kiểm tra nếu role là 'sale' thì tự động điều hướng đến '/sale'
    if (role === 'sale') {
      navigate('/sale');
    }
    // Kiểm tra nếu role là 'porter' thì tự động điều hướng đến '/port'
    if (role === 'customer') {
      navigate('/customer');
    }
    if (role === 'repair') {
      navigate('/repair');
    }

    if (role === 'tcth') {
      navigate('/general_finance');
    }
  }, [role, navigate]);

  return (
    <div className="homepage-background">
      <Container className="text-center mt-5">
        <h1>Đăng nhập thành công</h1>
        <Row className="justify-content-center mt-4">
          {role === 'admin' && (
            <>
              <Col xs="auto">
                <Button variant="primary" onClick={() => navigate('/drive')}>
                  Tài Xế
                </Button>
              </Col>
              <Col xs="auto">
                <Button variant="success" onClick={() => navigate('/manage')}>
                  Quản Lý
                </Button>
              </Col>
              <Col xs="auto">
                <Button variant="info" onClick={() => navigate('/sale')}>
                  Sale
                </Button>
              </Col>
              <Col xs="auto">
                <Button variant="info" onClick={() => navigate('/general_finance')}>
                  Tài chính
                </Button>
              </Col>
              <Col xs="auto">
                <Button variant="info" onClick={() => navigate('/customer')}>
                  Khách hàng
                </Button>
              </Col>
              <Col xs="auto">
                <Button variant="danger" onClick={() => navigate('/admin')}>
                  Admin
                </Button>
              </Col>
            </>
          )}
          {role === 'manager' && (
            <>
              <Col xs="auto">
                <Button variant="primary" onClick={() => navigate('/drive')}>
                  Tài Xế
                </Button>
              </Col>
              <Col xs="auto">
                <Button variant="success" onClick={() => navigate('/manage')}>
                  Quản Lý
                </Button>
              </Col>
            </>
          )}
          {role === 'repair' && (
            <Col xs="auto">
              <Button variant="success" onClick={() => navigate('/repair')}>
                Bảo dưỡng - Sửa chữa
              </Button>
          </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}

export default HomePage;
